module.exports = __webpack_public_path__ + "static/media/sung_noti.dd32c691.svg";